import { loadRuntimeConfig } from "@/config/runtimeConfig";
import { loadFlagsConfig } from "@/config/flagsConfig";
import { configureServicesFromRuntimeConfig } from "@/utils/services";

export const preloadRuntimeData = () => {
  const runtimeConfig = loadRuntimeConfig();
  loadFlagsConfig();
  configureServicesFromRuntimeConfig(runtimeConfig);
};
